import { render, staticRenderFns } from "./GroupTerms.vue?vue&type=template&id=4a997cdc&"
import script from "./GroupTerms.vue?vue&type=script&lang=js&"
export * from "./GroupTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports